import { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ErrorWrapper from '../ErrorWrapper'

export default class FormGroup extends Component {
  static propTypes = {
    externalErrors: PropTypes.array,
    validationErrors: PropTypes.array,
    className: PropTypes.string,
    errorsClassName: PropTypes.string,
  }
  static defaultProps = {
    externalErrors: [],
    validationErrors: [],
    className: 'form-group',
    errorsClassName: 'form-group--error',
  }

  getErrors() {
    let { externalErrors, validationErrors } = this.props
    validationErrors = validationErrors || []
    externalErrors = externalErrors || []
    if (validationErrors.length > 0) {
      return validationErrors
    } else if (externalErrors.length > 0) {
      return externalErrors
    }
    return []
  }

  render() {
    const { className, errorsClassName } = this.props
    const errors = this.getErrors()
    const classNames = classnames(className, { [errorsClassName]: errors.length > 0 })
    return (
      <div className={classNames}>
        <ErrorWrapper errors={errors}>{this.props.children}</ErrorWrapper>
      </div>
    )
  }
}
